import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

// Calculator Components
import AgeCalculator from './calculators/AgeCalculator';
import BMICalculator from './calculators/BMICalculator';
import WordCounter from './calculators/WordCounter';
import UnitConverter from './calculators/UnitConverter';
import TemperatureConverter from './calculators/TemperatureConverter';

const { FiArrowLeft } = FiIcons;

const CalculatorPage = ({ calculators }) => {
  const { calculatorId } = useParams();
  const navigate = useNavigate();

  const calculator = calculators.find(calc => calc.id === calculatorId);

  if (!calculator) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white text-center">
          <h2 className="text-2xl mb-4">Calculator not found</h2>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  const renderCalculator = () => {
    switch (calculatorId) {
      case 'age':
        return <AgeCalculator />;
      case 'bmi':
        return <BMICalculator />;
      case 'word-counter':
        return <WordCounter />;
      case 'area':
      case 'data':
      case 'length':
      case 'speed':
      case 'time':
      case 'volume':
      case 'weight':
        return <UnitConverter type={calculatorId} />;
      case 'temperature':
        return <TemperatureConverter />;
      default:
        return <div className="text-white">Calculator not implemented yet</div>;
    }
  };

  return (
    <div className="relative z-10 min-h-screen px-4 py-8">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <motion.button
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-purple-200 hover:text-white mb-8 transition-colors duration-300"
        >
          <SafeIcon icon={FiArrowLeft} className="text-xl" />
          Zurück
        </motion.button>

        {/* Calculator Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <div className={`w-16 h-16 rounded-2xl ${calculator.iconBg} flex items-center justify-center mx-auto mb-4`}>
            <SafeIcon 
              icon={calculator.icon} 
              className="text-3xl text-white"
            />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {calculator.title}
          </h1>
          <p className="text-lg text-purple-200/80 max-w-2xl mx-auto">
            {calculator.description}
          </p>
        </motion.div>

        {/* Calculator Component */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20"
        >
          {renderCalculator()}
        </motion.div>
      </div>
    </div>
  );
};

export default CalculatorPage;